import React, { useState, useContext, useEffect } from 'react';
import "../Css/LoginScreen.css";
import logo from "../Images/Logo.png";
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

function LoginScreen() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [isVerifying, setIsVerifying] = useState(true);
  const navigate = useNavigate();
  const {setIsAuthenticated } = useContext(AuthContext);

  // Check for existing authentication on component mount
  useEffect(() => {
    const checkAuthentication = async () => {
      setIsVerifying(true);
      
      const refreshToken = localStorage.getItem('refresh_token');
      
      if (!refreshToken) {
        setIsVerifying(false);
        return;
      }
      
      try {
        // Try to refresh the token - this implicitly validates authentication
        const refreshResponse = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/users/token/refresh/`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ refresh: refreshToken })
        });
        
        if (refreshResponse.ok) {
          // If refresh works, user is authenticated
          const data = await refreshResponse.json();
          localStorage.setItem('access_token', data.access);
          setIsAuthenticated(true);
          navigate('/home/dashboard');
        } else {
          // Invalid refresh token
          localStorage.removeItem('access_token');
          localStorage.removeItem('refresh_token');
          localStorage.removeItem('initial_data');
          setIsAuthenticated(false);
          setIsVerifying(false);
        }
      } catch (error) {
        console.error('Error refreshing token:', error);
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        setIsAuthenticated(false);
        setIsVerifying(false);
      }
    };
    
    checkAuthentication();
  }, [navigate, setIsAuthenticated]);

  const handleLogin = async (e) => {
    e.preventDefault();
    const startTime = Date.now();
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/users/token/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username, password }),
      });
      const endTime = Date.now();
      console.log(`Login request time: ${endTime - startTime}ms`);

      if (response.ok) {
        const data = await response.json();
        localStorage.setItem('access_token', data.access);
        localStorage.setItem('refresh_token', data.refresh);
        
        // Zapisz initial_data w localStorage lub w stanie aplikacji
        if (data.initial_data) {
          localStorage.setItem('initial_data', JSON.stringify(data.initial_data));
        }
        
        setIsAuthenticated(true);
        setErrorMessage('');
        navigate('/home/dashboard');
      } else {
        const errorData = await response.json();
        setErrorMessage(errorData.detail || 'Invalid credentials');
      }
    } catch (err) {
      console.error('Error:', err);
      setErrorMessage('Something went wrong. Please try again.');
    }
  };

  // Show loading state while verifying
  if (isVerifying) {
    return (
      <div className="flex column loginScreen center container">
        <div className="logo-container">
          <img src={logo} alt="Logo" />
        </div>
        <div className="verification-container">
          <div className="spinner"></div>
          <p className="verification-text">Weryfikacja sesji...</p>
        </div>
      </div>
    );
  }

  return (
    <div className='flex row loginScreen center container'>
      <div>
        <img src={logo} alt="Logo" />
      </div>
      <form onSubmit={handleLogin}>
        <input 
          type="text" 
          className="login" 
          placeholder="Adres email"
          value={username} 
          onChange={(e) => setUsername(e.target.value)} 
          autoComplete="username"
        />
        <input 
          type="password" 
          className="password" 
          placeholder="Password"
          value={password} 
          onChange={(e) => setPassword(e.target.value)} 
          autoComplete="current-password"
        />
        <button className="btn" type="submit">Zaloguj</button>
      </form>
      {errorMessage && <p className="error">{errorMessage}</p>}
    </div>
  );
}

export default LoginScreen;